import React from "react";
import styles from "../../styles/pages/home/PublicServicePage.module.scss";
import PublicEventDeck from "./PublicEventDeck";
import Leadership from "./Leadership";
import Hero from "./hero";


 const leadershipItems = [
    {
      id: "google-wtm",
      title: "Google Women Techmakers",
      subtitle: "Ambassador",
      image: "https://www.opportunitiesforafricans.com/wp-content/uploads/2023/05/google-women-techmakers.jpg",
      logo: "https://miro.medium.com/v2/resize:fit:686/1*-_zVpHOYFZgtzasKTJF8Pw.jpeg",
      tags: ["Equity", "Community", "STEM"],
      href: "https://women.google/techmakers/",
      accent: "#7C4DFF",
    },
    {
      id: "hack-for-la",
      title: "Hack for LA",
      subtitle: "Contributor",
      image: "https://www.hackforla.org/assets/images/projects-page/projects-hero.svg",
      logo: "https://avatars.githubusercontent.com/u/11635254?s=280&v=4",
      tags: ["Civic Tech", "Open Source"],
      href: "https://www.hackforla.org/",
      accent: "#8E24AA",
    },
    {
      id: "red-cross",
      title: "American Red Cross",
      subtitle: "Volunteer",
      image: "https://www.redcross.org/content/dam/redcross/local/news-articles/south-florida/DSC-1329.jpg",
      logo: "https://upload.wikimedia.org/wikipedia/commons/1/1a/Flag_of_the_Red_Cross.svg",
      tags: ["Relief", "Community"],
      href: "https://www.redcross.org/",
      accent: "#D32F2F",
    },
    {
      id: "un-collab",
      title: "United Nations",
      subtitle: "Collaborator",
      image: "https://maltmun.org/wp-content/uploads/2024/08/UNICEF.jpeg",
      logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ee/UN_emblem_blue.svg/2405px-UN_emblem_blue.svg.png",
      tags: ["Global Impact", "Policy"],
      href: "https://www.un.org/",
      accent: "#1473E6",
    },
  ];


const urgent = [
  {
    id: "u1",
    title: "Water access in Africa",
    figure: "~2B+",
    suffix: "People lack safely managed drinking water globally",
    // replace with Africa-specific stat if you have one
    sub: "Sub-Saharan communities face the steepest gaps.",
    image:
      "https://www.unicef.org/sites/default/files/styles/large/public/UN0591240.jpg.webp?itok=EFwWpATy",
    cta: "https://thewaterproject.org/",
    source: "https://thewaterproject.org/", // add source link you trust
  },
  {
    id: "u2",
    title: "Sponsor a child’s path out of poverty",
    figure: "1M+",
    suffix: "Millions of kids face hunger, missed school, and unsafe living conditions.",
    sub: "Sponsorship helps families stay stable and kids stay in school.",
    image:
      "https://sawabona-africa.com/wp-content/uploads/2023/04/option2-1-1.jpg",
    cta: "https://www.unbound.org/campaign/sponsor-in-africa",
    source: "https://www.charitynavigator.org/ein/431243999",
  },
  {
    id: "u3",
    title: "Burkina Faso national initiatives",
    figure: "2030",
    suffix: "Official national support fund",
    sub: "Direct, government-published channel for national support initiatives.",
    image:
      "https://www.worldbank.org/content/dam/photos/780x439/2023/jun/burkina-faso-economic-update-780x439.jpg",
    cta:"https://fasoarzeka.bf/",
    source:"https://fasoarzeka.bf/",
  },
];

export default function PublicServicePage() {
  return (
    <div className={styles.page}>

      < Hero />

      {/* <LeadershipReel /> */}

         <Leadership items={leadershipItems} autoPlay interval={4800} />;



            {/* <Leadership autoPlay interval={6500} /> */}



<section>
<PublicEventDeck
  variant="wide"
  intervalMs={3200}
  events={[
    {
      id: 101,
      title: "Google Cloud 2025",
      org: "Google",
      role: "Sponsored Attendance",
      date: "2025-05-09",
      endDate: "2025-05-11",
      location: "Las Vegas, Nevada",
      subtitle: "", // leave empty to auto-build from dates + location
      tags: ["sre", "observability", "oss"],
      description:
        "Sponsored to attend Google Cloud Next through the Google Techmakers Ambassador program.",
      experience:
        "Google Cloud conference (Google Cloud Next) is to showcase Google’s latest cloud products, AI updates, and platform roadmap through keynotes and demos. It also helps developers and businesses learn best practices via technical sessions and hands-on labs.",
      // stats: [
      //   { label: "Workshops", value: "2" },
      //   { label: "Speakers", value: "12" },
      //   { label: "NPS", value: "+68" },
      // ],

      link: "https://io.google/2025/",
      image: "https://storage.googleapis.com/gweb-cloudblog-publish/images/4_next25_wrap.max-2000x2000.jpg",
    },
    // other events...

    {
      id: 102,
      title: "Annual Legislative  Conference 2025",
      org: "Congressional Black Caucus Foundation",
      role: "Volunteer",
      date: "2025-09-24",
      endDate: "2025-09-28",
      location: "Washington D.C, U.S.A",
      subtitle: "", // leave empty to auto-build from dates + location
      tags: ["sre", "observability", "oss"],
      description:
        "Volunteered at the [Congressional] Black Caucus Annual Legislative Conference, supporting event logistics.",
         experience:
        "The Congressional Black Caucus Annual Legislative Conference (CBC-ALC) brings together policymakers, advocates, business leaders, and community members to discuss issues affecting Black communities and the nation. Its purpose is to create space for people of color community.",
      link: "#",
      image: "https://www.cbcfinc.org/wp-content/uploads/2025/07/CBCF-ALC-54-press-release-min.png",
    },

    {
      id: 103,
      title: "LA Tech Week 2025",
      org: "Ritual Ads",
      role: "Director",
      date: "2025-10-18",
      endDate: "2025-10-18",
      location: "Los Angeles, California",
      subtitle: "", // leave empty to auto-build from dates + location
      tags: ["sre", "observability", "oss"],
      description:
        "Directed and led end-to-end planning and execution of LA Tech Week 2025, coordinating programming, partners, and on-site operations.",
      experience:
        "LA Tech Week is a citywide series of events that brings together founders, engineers, investors, and community leaders across Los Angeles. Its purpose is to showcase LA’s tech ecosystem,  collaboration, and create opportunities through talks, networking, demos, and partner events.",
      link: "#",
      image: "https://cdn.prod.website-files.com/61941a8ca6c4b5ab930d9a16/66bd103bbecf4932ffea6370_Tech%20Week%202024%20Banner%20530x442.png",
    },
  ]}
/>

</section>
        {/* URGENT CAUSES */}
      <section id="urgent" className={styles.section}>
        <div className={styles.sectionHead}>
          <h2 className={styles.sectionTitle}>Urgent issues and Causes</h2>
          <p className={styles.sectionSub}>
            Social problems. Real numbers. Concrete ways to help.
          </p>
        </div>
        <div className={styles.grid3}>
          {urgent.map((c) => (
            <div key={c.id} className={`${styles.card} ${styles.cardTall}`}>
              <img className={styles.cardImg} src={c.image} alt={c.title} />
              <div className={`${styles.overlay} ${styles.overlayGradient}`} />
              <div className={styles.cardTop}>
                <span className={styles.chip}>{c.title}</span>
              </div>
              <div className={styles.cardBottom}>
                <div className={styles.figureRow}>
                  <span className={styles.figure}>{c.figure}</span>
                  <span className={styles.suffix}>{c.suffix}</span>
                </div>
                <div className={styles.meta}>{c.sub}</div>
                <div className={styles.rowGap}>
                  <a className={styles.btnPrimarySm} href={c.cta}>Take action</a>
                  <a className={styles.btnGhostSm} href={c.source}>Source</a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
